const sparkLineData = {
    avgArAge: { data: [], metrics: {}, format: 'n2' },
    netCash: { data: [], metrics: {}, format: '###.00 "%"' },
    overUnder: { data: [], metrics: {}, format: 'c0' },
    retainage: { data: [], metrics: {}, format: 'c0' },
    totalField: { data: [], metrics: {}, format: '####.##' },
    avgField: { data: [], metrics: {}, format: 'c2' },
    prodCost: { data: [], metrics: {}, format: '####.##' },
    prodHours: { data: [], metrics: {}, format: '####.##' },
    pcoAmount: { data: [], metrics: {}, format: 'c0' },
    pcoBooked: { data: [], metrics: {}, format: '###.00 "%"' },
    potentialUpside: { data: [], metrics: {}, format: 'c0' }
};

let columnsGenerated = false;
const columnData = [];
const chartColumnData = [];

function getValues(data, type) {
    if (type !== 'read') return data;
    const extra = {};
    extra.sourceName = $('a.menu-topbar__link.--active')[0].text;
    extra.company =
        $('#viewLevel').val() ||
        $('#changeCompany--js')
            .find('a.menu-settings__link--active')
            .attr('data-value');
    extra.timePeriod = $('#timePeriod').val() || 1;
    extra.division = $('#division').val() || '';
    const $pm = $('#projectManager').data('kendoAutoComplete');
    const $p = $('#project').data('kendoAutoComplete');
    extra.projectManager =
        $pm.dataSource.view().find(item => {
            const val = $pm.element.val();
            return item.text === val;
        })?.value || -1;
    extra.project =
        $p.dataSource.view().find(item => {
            const val = $p.element.val();
            return item.text === val;
        })?.value || '';
    return $.extend(data, extra);
}

function onMetricRequestEnd(arg) {
    if (arg.type === 'read' && arg.response !== undefined && arg.response.length > 0) {
        arg.response.forEach(function(row) {
            const that = {};
            Object.assign(that, row);
            const measureName = that.mName.trim();
            delete that.mName;
            delete that.mid;
            let metricSource;
            if (measureName === 'projectAvgAgeAR') metricSource = sparkLineData.avgArAge.metrics;
            if (measureName === 'projectNetCash') metricSource = sparkLineData.netCash.metrics;
            if (measureName === 'Total Field Count') metricSource = sparkLineData.totalField.metrics;
            if (measureName === 'Average Field Wage') metricSource = sparkLineData.avgField.metrics;
            if (measureName === 'projectLaborProdCost') metricSource = sparkLineData.prodCost.metrics;
            if (measureName === 'projectLaborProdHours') metricSource = sparkLineData.prodHours.metrics;
            if (measureName === 'projectPotentialUpside') metricSource = sparkLineData.potentialUpside.metrics;
            if (measureName === 'projectPcoABPercBooked') metricSource = sparkLineData.pcoBooked.metrics;
            if (measureName === 'projectPotentialUpside') metricSource = sparkLineData.potentialUpside.metrics;
            if (metricSource === undefined) return;
            while (metricSource.length > 0) metricSource.pop();
            Object.assign(metricSource, that);
        });
    }
}

const metricDataSource = new kendo.data.DataSource({
    transport: {
        read: {
            url: '/Account/Scorecard/GetProjectMetrics',
            dataType: 'json'
        },
        parameterMap: getValues
    },
    requestEnd: onMetricRequestEnd
});

function onGridRequestStart(arg) {
    if (arg.type === 'read') {
        metricDataSource.read();
        Object.keys(sparkLineData).forEach(function(key) {
            const dataSource = sparkLineData[key]?.data;
            while (dataSource !== undefined && dataSource.length > 0) dataSource.pop();
        });
    }
}

function refreshSparklines() {
    const tabName = $('a.menu-topbar__link.--active')[0].text;
    $(document).trigger('on:RenderSparklines', [{ tabName }]);
}

function getFormattedValue(measure, value) {
    let returnValue = kendo.toString(value, 'n2');
    if (['Total Field Count', 'Cost Productivity', 'Productive Hours'].indexOf(measure) >= 0)
        returnValue = `${kendo.toString(value, '####.##')}`;
    if (['Average Field Wage'].indexOf(measure) >= 0) returnValue = `${kendo.toString(value, 'c2')}`;
    if (['Net Cash', 'PCO Recovery %'].indexOf(measure) >= 0) returnValue = `${kendo.toString(value, '###.00 "%"')}`;
    if (['Over/(Under) Vs. Elements', 'Retainage Vs. Elements', "Total PCO's Booked", 'Contingency'].indexOf(measure) >= 0)
        returnValue = `${kendo.toString(value, 'c0')}`;
    return returnValue;
}

function onGridRequestEnd(arg) {
    if (arg.type === 'read' && arg.response.length > 0) {
        columnsGenerated = false;
        arg.response.forEach(function(row) {
            const that = {};
            Object.assign(that, row);
            const measureName = that.measure;
            Object.keys(that).forEach(function(key) {
                if (key === 'measure') delete that.measure;
                if (key === 'mDesc') delete that.mDesc;
                if (key.endsWith('_status')) delete that[key];
                if (key.endsWith('_target')) {
                    const metricKey = key.replace('_target', '');
                    if (measureName === 'Over/(Under) Vs. Elements') sparkLineData.overUnder.metrics[metricKey] = that[key];
                    if (measureName === 'Retainage Vs. Elements') sparkLineData.retainage.metrics[metricKey] = that[key];
                    delete that[key];
                }
            });

            if (!columnsGenerated) {
                columnData.splice(0, columnData.length);
                const measureColumn = {};
                measureColumn.field = 'measure';
                measureColumn.title = '&nbsp;';
                measureColumn.locked = true;
                measureColumn.width = 190;
                measureColumn.template = function(dataItem) {
                    return `
                        <button class="flex flex-no-wrap items-center scorecard__popup-toggle"> 
                            <span class="k-icon k-i-more-vertical k-icon-sm"></span>
                            <span>${kendo.htmlEncode(dataItem.measure)}</span>
                        </button>
                        <span class="scorecard__popup-content popup measure">
                            <p><strong>${kendo.htmlEncode(dataItem.measure)}</strong></p>
                            ${dataItem.mDesc}
                        </span>
                    `;
                };
                columnData.push(measureColumn);
                Object.keys(that).forEach(function(key) {
                    const keyStatus = `${key}_status`;
                    const column = {};
                    column.field = key;
                    column.title = key;
                    column.width = 100;
                    column.attributes = { style: '' };
                    column.template = dataItem => {
                        if (dataItem[key] === null) {
                            return `<span class="grid-cell--status --blank" data-status="${kendo.htmlEncode(
                                dataItem[keyStatus]
                            )}"><span class="k-icon k-i-minus"></span></span>`;
                        }
                        let value = dataItem[key];
                        value = getFormattedValue(dataItem.measure, value);
                        return `<span class="grid-cell--status" data-status="${kendo.htmlEncode(dataItem[keyStatus])}">${value}</span>`;
                    };
                    columnData.push(column);
                });
                columnsGenerated = true;
            }

            const data = [];
            Object.keys(that).forEach(function(key) {
                data.push(that[key]);
            });
            let dataSource;
            if (measureName === 'Avg. AR Age') dataSource = sparkLineData.avgArAge.data;
            if (measureName === 'Over/(Under) Vs. Elements') dataSource = sparkLineData.overUnder.data;
            if (measureName === 'Retainage Vs. Elements') dataSource = sparkLineData.retainage.data;
            if (measureName === 'Net Cash') dataSource = sparkLineData.netCash.data;
            if (measureName === 'Total Field Count') dataSource = sparkLineData.totalField.data;
            if (measureName === 'Average Field Wage') dataSource = sparkLineData.avgField.data;
            if (measureName === 'Cost Productivity') dataSource = sparkLineData.prodCost.data;
            if (measureName === 'Productive Hours') dataSource = sparkLineData.prodHours.data;
            if (measureName === "Total PCO's Booked") dataSource = sparkLineData.pcoAmount.data;
            if (measureName === 'PCO Recovery %') dataSource = sparkLineData.pcoBooked.data;
            if (measureName === 'Contingency') dataSource = sparkLineData.potentialUpside.data;
            if (dataSource !== undefined) Object.assign(dataSource, data);
        });
        refreshSparklines();
    }
}

const gridDataSource = new kendo.data.DataSource({
    transport: {
        read: {
            url: '/Account/Scorecard/GetProjectData',
            dataType: 'json'
        },
        parameterMap: getValues
    },
    requestStart: onGridRequestStart,
    requestEnd: onGridRequestEnd
});

export { sparkLineData };
export { gridDataSource };
export { columnData };
export { chartColumnData };
